// extracted by mini-css-extract-plugin
module.exports = {"list":"social-media-link-list_list__L6P91"};